module.exports = __webpack_public_path__ + "static/media/epark-provider.c08dbe4d.svg";